import { VIRTUAL_USER_GAP_SEVERITY } from "@demandproai/shared";
import RenderIf from "./render-if/Renderif";
import XLink from "./common/XLink";
import XButton from "./common/XButton";
import useVirtualUserRerun from "../hooks/useVirtualUserRerun";
import { buildGapReviewRows, buildGapReviewSummary } from "../utils/easyModeGapReview";

const panelHeaderClasses = "flex justify-between items-center bg-primary-surface px-4! py-2! rounded-t-md!";
const panelBodyClasses = "border-4! border-primary-surface! border-t-0! p-4! rounded-b-md!";
const summaryClasses = "text-subtle text-sm mb-3!";
const rowClasses = "flex flex-col gap-1 py-3! border-b border-border last:border-b-0";
const rowHeaderClasses = "flex items-center gap-2 flex-wrap";
const titleClasses = "text-heading font-semibold";
const detailClasses = "text-content text-sm mb-0!";
const footnoteClasses = "text-muted text-xs mt-3! mb-0!";
const badgeClasses = "text-xs uppercase tracking-wide px-2! py-0.5! rounded";

const SEVERITY_BADGE_CLASSES = {
    [VIRTUAL_USER_GAP_SEVERITY.BLOCKING]: `${badgeClasses} bg-danger text-white`,
    [VIRTUAL_USER_GAP_SEVERITY.WARNING]: `${badgeClasses} bg-warning-surface text-warning`,
    [VIRTUAL_USER_GAP_SEVERITY.INFO]: `${badgeClasses} bg-surface-light text-subtle`
};

const CaseGapReviewPanel = ({ caseId, gapReport, caseInfo }) => {
    const rows = buildGapReviewRows({ gapReport, caseId });
    const { rerun, isRerunning } = useVirtualUserRerun({ caseId, caseInfo });

    if (!rows.length) return null;

    return (
        <div className="row">
            <div className="col-md-12">
                <div className={panelHeaderClasses}>
                    <strong>Assistant Review</strong>

                    <RenderIf shouldRender={Boolean(caseInfo)}>
                        <XButton variant="primary" onClick={rerun} disabled={isRerunning}>
                            {isRerunning ? "Re-running..." : "Re-run assistant"}
                        </XButton>
                    </RenderIf>
                </div>

                <div className={panelBodyClasses}>
                    <p className={summaryClasses}>{buildGapReviewSummary({ gapReport })}</p>

                    {rows.map((row) => (
                        <div key={row.key} className={rowClasses}>
                            <div className={rowHeaderClasses}>
                                <span className={SEVERITY_BADGE_CLASSES[row.severity] ?? SEVERITY_BADGE_CLASSES[VIRTUAL_USER_GAP_SEVERITY.INFO]}>
                                    {row.severity}
                                </span>

                                <span className={titleClasses}>{row.title}</span>
                            </div>

                            <p className={detailClasses}>{row.detail}</p>

                            <RenderIf shouldRender={Boolean(row.stepLink)}>
                                <XLink to={row.stepLink?.url}>Fix in {row.stepLink?.label}</XLink>
                            </RenderIf>
                        </div>
                    ))}

                    <p className={footnoteClasses}>
                        Recorded when the assistant last finished this case. Fix the items in Case Intake, then Re-run
                        the assistant to refresh this review.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CaseGapReviewPanel;
